import { useContext } from 'react';

import { RenderingContext } from './rendering-context';

/**
 * Read this component's content slice as the caller-supplied domain type.
 *
 * Replaces Sitecore's `useContent<TRendering>()` + `f('a.b.value')` getter.
 * The adapter is responsible for flattening provider-specific field wrappers
 * (e.g. JSS `{ value: ... }`) before this hook sees them.
 */
export const useContent = <T>(): T => {
  const rendering = useContext(RenderingContext);
  if (!rendering) {
    throw new Error('useContent must be called inside a CMS-rendered component');
  }
  return rendering.content as T;
};
